import { render } from "./PsychicRegistration.vue?vue&type=template&id=63958457&scoped=true"
import script from "./PsychicRegistration.vue?vue&type=script&lang=js"
export * from "./PsychicRegistration.vue?vue&type=script&lang=js"

import "./PsychicRegistration.vue?vue&type=style&index=0&id=63958457&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63958457"]])

export default __exports__